export const updateFlowConfigDocumentationMarkdown = `
# Update Flow Configuration

Allows specifying the Entity or Practice (by ID) against which the flow will run from this block forward
`;
